import PropTypes from 'prop-types';
import ConnectedAlignmentWidget from "./ConnectedAlignmentWidget.js";
import OutcomeSDKComponent from "./OutcomeSDKComponent.js";
export default OutcomeSDKComponent(ConnectedAlignmentWidget, {
  artifactType: PropTypes.string,
  artifactId: PropTypes.string,
  screenreaderNotification: PropTypes.func
});